import { Component, OnInit, Input, ChangeDetectorRef, OnChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CommonDataService } from '../../../shared/services/common-data.service';
import { AdminService } from '../../../admin/admin.service';
import { UserService } from '../../../auth/user.service';
import * as _ from 'underscore';
import { v4 as uuid } from 'uuid';

@Component({
	selector: 'app-site-edit',
	templateUrl: './site-edit.component.html',
	styleUrls: ['./site-edit.component.css'],
	viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class SiteEditComponent implements OnInit, OnChanges {
	hasENERNOCProvider = false;
	@Input() mode: String = 'devices';
	@Input() site: any;
	@Input() readyArrays: boolean = false;
	@Input() OEMsInfo: Array<any> = [];
	@Input() dealersInfo: Array<any> = [];
	@Input() serviceDealersInfo: Array<any> = [];
	@Input() truckDealersInfo: Array<any> = [];
	@Input() ACTusers: Array<any> = [];
	@Input() siteOwners: Array<any> = [];
	@Input() onNameChange !: () => void;
	@Input() onAddressChange !: () => void;

	TimeZonesMenu = <any>[];
	minInstallationDate = new Date(2015, 1, 1);
	allDealerUsers	= {};
	dealerUsers		= [];
	serviceDealerUsers = [];
	truckDealerUsers = [];
	currentUser: any = {};
	token : string = "";
	siteWasActFirst: boolean = false;
	validToken: boolean = false;
	capBatteryIdInput: string = "";

	constructor(
		private commonData: CommonDataService,
		private chRef: ChangeDetectorRef,
		private adminService: AdminService,
		public userService: UserService
	) {
	}

	ngOnInit() {
		this.TimeZonesMenu = this.commonData['TimeZonesMenu'];
		this.currentUser = this.userService.getCurrentUser();
		this.hasENERNOCProvider = this.adminService.hasENERNOCProvider;
	}

	ngOnChanges(changes) {
		let noOEM			= {'id':0, 'name':'- No OEM -'};
		let noServiceDealer	= {'id':0, 'name':'- No Service Dealer Primary -'};
		let noTruckDealer	= {'id':0, 'name':'- None -'};

		if(!this.readyArrays && changes.OEMsInfo && changes.OEMsInfo.currentValue !== undefined && changes.OEMsInfo.currentValue.length > 0) {
			this.OEMsInfo = [noOEM].concat(changes.OEMsInfo.currentValue);
		}

		if(!this.readyArrays && changes.serviceDealersInfo && changes.serviceDealersInfo.currentValue !== undefined && changes.serviceDealersInfo.currentValue.length > 0) {
			this.serviceDealersInfo = [noServiceDealer].concat(changes.serviceDealersInfo.currentValue);
		}

		if(!this.readyArrays && changes.truckDealersInfo && changes.truckDealersInfo.currentValue !== undefined && changes.truckDealersInfo.currentValue.length > 0) {
			this.truckDealersInfo = [noTruckDealer].concat(changes.truckDealersInfo.currentValue);
		}

		if(changes.ACTusers && changes.ACTusers.currentValue !== undefined && changes.ACTusers.currentValue.length > 0) {
			changes.ACTusers.currentValue.forEach(function(user) {
				user['name'] = user['firstname'] + ' ' + user['lastname'];
			});
			this.ACTusers = _.sortBy(changes.ACTusers.currentValue, 'name');
		}

		if(changes.siteOwners && changes.siteOwners.currentValue !== undefined && changes.siteOwners.currentValue.length > 0) {
			changes.siteOwners.currentValue.forEach(function(user) {
				user['name'] = user['firstname'] + ' ' + user['lastname'];
			});
			this.siteOwners = _.sortBy(changes.siteOwners.currentValue, 'name');
		}

		if (changes.site && changes.site.currentValue !== undefined) {
			this.token = this.site['act_first_token'];
			this.siteWasActFirst = this.site.act_first_enabled;
			this.validToken = this.siteWasActFirst;
			if(!this.site.dr_provider)
				this.site.dr_provider = 'None';

			if (this.site.dr_phones_whitelist) {
				let phonesListView = [];
				for (let item of this.site.dr_phones_whitelist) {
					phonesListView.push({value: item});
				}
				this.site.dr_phones_whitelist = phonesListView;
			} else {
				this.site.dr_phones_whitelist = [{value: ""}];
			}

			// Initialize CAP properties
			if (!this.site.cap_enabled) {
				this.site.cap_enabled = false;
			}
			if (!this.site.cap_battery_ids) {
				this.site.cap_battery_ids = [];
			} else {
				// Migrate old string-based format to new object format with status
				this.site.cap_battery_ids = this.site.cap_battery_ids.map(item => {
					if (typeof item === 'string') {
						return { id: item, status: 'allowed' };
					}
					return item;
				});
			}
		}
	}

	updateSiteCoords(coords) {
		this.site['latitude'] = coords['lat'];
		this.site['longitude'] = coords['lng'];
		this.site['address'] = coords['address'];
		this.site['country'] = coords['country'];
		this.site['state'] = coords['state'];
		// Add city and zipcode from Google Maps (if available)
		if (coords['city']) {
			this.site['city'] = coords['city'];
		}
		if (coords['zipcode']) {
			this.site['zipcode'] = coords['zipcode'];
		}
		this.chRef.detectChanges();

		// Trigger address change callback if provided (for duplicate detection)
		if (this.onAddressChange) {
			this.onAddressChange();
		}
	}

	getDealerUsers(id, type) {
		if(this.mode != 'manage' || !id)
			return;

		switch(type) {
			case 'dealer':
				this.site.dealer_users = [];
				break;
			case 'service':
				this.site.service_dealer_users = [];
				break;
			case 'truck':
				this.site.truck_dealer_users = [];
				break;
		}

		if(this.allDealerUsers[id]) {
			switch(type) {
				case 'dealer':
					this.dealerUsers = this.allDealerUsers[id];
					break;
				case 'service':
					this.serviceDealerUsers = this.allDealerUsers[id];
					break;
				case 'truck':
					this.truckDealerUsers = this.allDealerUsers[id];
					break;
			}
			return;
		}
		this.adminService.getDealerUsers(id).subscribe(
			(response:any) => {

				response.forEach(function(user) {
					user['name'] = user['firstname'] + ' ' + user['lastname'];
				});
				if(this.currentUser.isDealer && this.currentUser.dealerid == id) {
					response.forEach((user, i) => {
						if(user.id == this.currentUser.id) {
							response.splice(i, 1); //remove user
							i--;
						}
					});
				}

				this.allDealerUsers[id]	= response;

				switch(type) {
					case 'dealer':
						this.dealerUsers = response;
						break;
					case 'service':
						this.serviceDealerUsers = response;
						break;
					case 'truck':
						this.truckDealerUsers = response;
						break;
				}
			}
		);
	}

	checkUser(user, type) {
		if(!user.id) {

			switch(type) {
				case 'dealer':
					this.site.dealer_users.pop();
					break;
				case 'service':
					this.site.service_dealer_users.pop();
					break;
				case 'truck':
					this.site.truck_dealer_users.pop();
					break;
			}
		}
	}

	generateToken(regenerate) {
		if (this.site.act_first_enabled && (regenerate || !this.site['act_first_token'] || this.site['act_first_token'] != this.token )) {
			let token = this.site.id + uuid();
			this.site['act_first_token'] = token;
			this.token = token;
			this.validToken = false;
		}
	}

	addNewDRPhoneWhiteList() {
		this.site.dr_phones_whitelist.push({value:""});
	}

	/**
	 * Handle Charge Authorization Program toggle
	 * Initialize cap_battery_ids array if CAP is being enabled
	 */
	onCAPToggle() {
		if (this.site.cap_enabled && (!this.site.cap_battery_ids || !Array.isArray(this.site.cap_battery_ids))) {
			this.site.cap_battery_ids = [];
		}
		if (!this.site.cap_enabled) {
			this.site.cap_battery_ids = [];
		}
	}

	/**
	 * Add battery IDs from comma-separated input
	 * Validates and deduplicates IDs before adding
	 * Each ID is stored as object with status property: {id: "123456", status: "allowed"}
	 */
	addBatteryIds() {
		if (!this.capBatteryIdInput || this.capBatteryIdInput.trim() === '') {
			return;
		}

		// Initialize array if needed
		if (!this.site.cap_battery_ids) {
			this.site.cap_battery_ids = [];
		}

		// Split by comma, trim whitespace, filter empty strings
		const newIds = this.capBatteryIdInput
			.split(',')
			.map(id => id.trim())
			.filter(id => id.length > 0);

		// Add unique IDs to the list with "allowed" status by default
		for (const newId of newIds) {
			// Check if ID already exists in the list (handles both old string format and new object format)
			const exists = this.site.cap_battery_ids.some(item => this.getBatteryIdValue(item) === newId);
			if (!exists) {
				// Store as object with status
				this.site.cap_battery_ids.push({
					id: newId,
					status: 'allowed'
				});
			}
		}

		// Clear input after adding
		this.capBatteryIdInput = '';
	}

	/**
	 * Remove a battery ID from the list
	 */
	removeBatteryId(index: number) {
		if (this.site.cap_battery_ids && index >= 0 && index < this.site.cap_battery_ids.length) {
			this.site.cap_battery_ids.splice(index, 1);
		}
	}

	/**
	 * Get the Battery ID value from an item (handles both string and object formats)
	 * For backward compatibility with existing string-based data
	 */
	getBatteryIdValue(item: any): string {
		if (typeof item === 'string') {
			return item;
		}
		return item?.id || '';
	}

	/**
	 * Get the status value from an item (handles both string and object formats)
	 * Defaults to "allowed" for backward compatibility
	 */
	getStatusValue(item: any): string {
		if (typeof item === 'string') {
			return 'allowed'; // Default to allowed for legacy string format
		}
		return item?.status || 'allowed';
	}

	/**
	 * Toggle the status of a battery ID between "allowed" and "denied"
	 */
	toggleBatteryIdStatus(index: number) {
		if (this.site.cap_battery_ids && index >= 0 && index < this.site.cap_battery_ids.length) {
			const item = this.site.cap_battery_ids[index];
			const currentStatus = this.getStatusValue(item);
			const newStatus = currentStatus === 'allowed' ? 'denied' : 'allowed';

			// Convert to object format if it's still a string
			if (typeof item === 'string') {
				this.site.cap_battery_ids[index] = {
					id: item,
					status: newStatus
				};
			} else {
				this.site.cap_battery_ids[index].status = newStatus;
			}
		}
	}

}
